<template>
  <section class="f-75">
    <div class="alive_content f-select-center">
      <div>
        <div class="title f-center-title">
          <div>移动空间</div>
          <div>在车上下载移动应用</div>
        </div>
        <div class="des f-center-sub-title">
          <div>用户可自行下载三方移动应用，独立安装，数据隔离；</div>
          <div>此处仅为功能演示，不针对特定应用开发</div>
        </div>
      </div>
      <div v-ia>
        <div class="border_container_light img_container">
          <img :src="Img1" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Img1 from '@/v2/auto/assets/image/75/1-1.jpg'
export default {
  components: {},
  data() {
    return {
      preload_: true,
      activeIndex: 0,
      Img1,
    }
  },
  mounted() {},
  methods: {},
}
</script>
<style lang="less" scoped>
.f-75 {
  width: 100%;
  position: sticky;
  overflow: hidden;
  z-index: 79;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 200px;

  .alive_content {
    height: auto;
    display: flex;
    align-items: center;
    .title {
      display: flex;
      flex-direction: column;
      width: max-content;
      background: radial-gradient(
        183.11% 411.81% at 24.05% -41.32%,
        #0066ff 0%,
        #00d66b 99.5%
      );
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
      font-weight: 700;
      line-height: 1.2;
      margin-bottom: 24px;
    }

    .des {
      margin: 10px 0 32px;
      line-height: 1.5;
      color: #00000080;
      max-width: 456px;
    }

    .img_container {
      margin-left: 145px;
      width: 1200px;
      height: 750px;
      @media screen and (max-width: 1920px) {
        width: 1000px;
        height: 625px;
      }
      @media screen and (max-width: 1680px) {
        width: 880px;
        height: 550px;
      }
      img {
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  }
}
</style>
